export const SyllabusData = {
  categories: [
    {
      id: 1,
      title: "HTML",
      description: "Learn the foundation of web development.",
      route: "/html",
      status: "active"
    },
    {
      id: 2,
      title: "CSS",
      description: "Style and design beautiful web pages.",
      route: "/sorryy",
      status: "beta"
    },
    {
      id: 3,
      title: "JavaScript",
      description: "Make your websites interactive.",
      route: "/javascript",
      status: "active"
    },
    {
      id: 4,
      title: "React",
      description: "Build modern UI using components.",
      route: "/sorryy",
      status: "beta"
    },
    {
      id: 5,
      title: "SQL",
      description: "Manage and query databases.",
      route: "/sql",
      status: "active"
    },
    {
      id: 6,
      title: "Java",
      description: "Backend programming with Java.",
      route: "/sorryy",
      status: "beta"
    },
    {
      id: 7,
      title: "SpringBoot",
      description: "Backend Development with SpringBoot.",
      route: "/sorryy",
      status: "beta"
    }
  ]
}